module.exports = {
    extends: [
        '/',
        'templates',
        'ninja',
        'propertiesForm',
    ],
}